/* Racket Rush — Diwali Sale 2026 FX (no dependencies)
   1) Firecracker burst on button clicks (canvas overlay, pointer-events:none, never blocks clicks)
   2) Sale countdown + time-aware states
   3) Tap-to-copy coupon codes
   4) Announcement rotator */
(function () {
  'use strict';
  var SALE_START = Date.parse('2026-11-01T00:00:00+05:30');
  var SALE_END = Date.parse('2026-11-10T23:59:59+05:30');
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- 1. Firecracker burst ---------- */
  var SELECTOR = 'button, .button, .btn, [class*="btn"], [role="button"], input[type="submit"], input[type="button"], .shopify-payment-button__button, .diwali-copy, .prod-card__size-pill';
  var COLORS = ['#ffd76a', '#ffb703', '#ff7b00', '#ff3d3d', '#fff3c4', '#d7ff3f', '#ff5fa2'];
  var canvas = null, ctx = null, parts = [], rings = [], raf = 0, dpr = 1;

  function setup() {
    if (canvas) return true;
    try {
      canvas = document.createElement('canvas');
      canvas.className = 'diwali-fx-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483646;';
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      resize();
      window.addEventListener('resize', resize, { passive: true });
      return !!ctx;
    } catch (e) { return false; }
  }
  function resize() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
  }
  function burst(x, y) {
    if (reduceMotion || !setup()) return;
    var n = window.innerWidth < 600 ? 34 : 46;
    for (var i = 0; i < n; i++) {
      var a = (Math.PI * 2 * i) / n + Math.random() * 0.3;
      var sp = 2.2 + Math.random() * 4.2;
      parts.push({
        x: x, y: y, px: x, py: y,
        vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1.2,
        life: 0, max: 40 + Math.random() * 22,
        c: COLORS[(Math.random() * COLORS.length) | 0],
        w: 1.6 + Math.random() * 1.8,
        twinkle: Math.random() < 0.35
      });
    }
    for (var j = 0; j < 10; j++) { // tiny crackle sparks
      parts.push({ x: x, y: y, px: x, py: y, vx: (Math.random() - 0.5) * 9, vy: (Math.random() - 0.5) * 9, life: 0, max: 18 + Math.random() * 10, c: '#ffffff', w: 1.2, twinkle: true });
    }
    rings.push({ x: x, y: y, r: 4, life: 0, max: 16 });
    if (parts.length > 600) parts.splice(0, parts.length - 600);
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function tick() {
    raf = 0;
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'lighter';
    for (var k = rings.length - 1; k >= 0; k--) {
      var g = rings[k]; g.life++; g.r += 3.2;
      var ga = 1 - g.life / g.max;
      if (ga <= 0) { rings.splice(k, 1); continue; }
      ctx.beginPath(); ctx.arc(g.x, g.y, g.r, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(255,215,106,' + (ga * 0.7).toFixed(3) + ')'; ctx.lineWidth = 2; ctx.stroke();
    }
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.life++;
      if (p.life >= p.max) { parts.splice(i, 1); continue; }
      p.px = p.x; p.py = p.y;
      p.vx *= 0.955; p.vy = p.vy * 0.955 + 0.11;
      p.x += p.vx; p.y += p.vy;
      var al = 1 - p.life / p.max;
      if (p.twinkle && Math.random() < 0.3) al *= 0.3;
      ctx.globalAlpha = al;
      ctx.strokeStyle = p.c; ctx.lineWidth = p.w; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(p.px - p.vx * 1.6, p.py - p.vy * 1.6); ctx.lineTo(p.x, p.y); ctx.stroke();
    }
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    if (parts.length || rings.length) raf = requestAnimationFrame(tick);
    else ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  function hit(t) {
    if (!t || !t.closest) return null;
    var el = t.closest(SELECTOR);
    if (!el) return null;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return null;
    return el;
  }
  // pointerdown: fires before navigation; passive + no preventDefault => never blocks the click.
  document.addEventListener('pointerdown', function (e) {
    try { if (e.button > 0) return; if (hit(e.target)) burst(e.clientX, e.clientY); } catch (err) {}
  }, { capture: true, passive: true });
  // keyboard-activated clicks (Enter/Space) have detail === 0
  document.addEventListener('click', function (e) {
    try {
      if (e.detail !== 0) return;
      var el = hit(e.target); if (!el) return;
      var r = el.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2);
    } catch (err) {}
  }, { capture: true, passive: true });

  /* ---------- 2. Countdown + time-aware state ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function saleState(now) { return now < SALE_START ? 'pre' : (now <= SALE_END ? 'live' : 'ended'); }
  function updateTimers() {
    var now = Date.now();
    var state = saleState(now);
    document.documentElement.setAttribute('data-diwali-sale', state);
    var els = document.querySelectorAll('[data-diwali-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var target = state === 'pre' ? SALE_START : SALE_END;
      var label = el.querySelector('[data-cd-label]');
      var boxes = el.querySelector('[data-cd-boxes]');
      if (state === 'ended') {
        if (label) label.textContent = 'Sale ended';
        if (boxes) boxes.hidden = true;
        continue;
      }
      if (label) label.textContent = state === 'pre' ? (el.getAttribute('data-pre-label') || 'Sale starts in') : (el.getAttribute('data-live-label') || 'Sale ends in');
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      var set = function (k, v) { var n = el.querySelector('[data-cd-' + k + ']'); if (n && n.textContent !== v) n.textContent = v; };
      set('d', pad(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      if (boxes) boxes.hidden = false;
    }
    var st = document.querySelectorAll('[data-diwali-state-text]');
    for (var j = 0; j < st.length; j++) {
      var v = st[j].getAttribute('data-' + state);
      if (v != null && st[j].textContent !== v) st[j].textContent = v;
    }
  }

  /* ---------- 3. Copy coupon ---------- */
  function copyText(txt) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(txt).catch(function () { return legacyCopy(txt); });
    }
    return legacyCopy(txt);
  }
  function legacyCopy(txt) {
    return new Promise(function (res, rej) {
      try {
        var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:-1000px;opacity:0;'; document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy'); document.body.removeChild(ta); ok ? res() : rej();
      } catch (e) { rej(e); }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-copy-code]') : null;
    if (!b) return;
    var code = b.getAttribute('data-copy-code');
    var lab = b.querySelector('[data-copy-label]') || b;
    var orig = b.getAttribute('data-orig') || lab.textContent; b.setAttribute('data-orig', orig);
    copyText(code).then(function () { lab.textContent = 'COPIED ✓'; b.classList.add('is-copied'); },
      function () { lab.textContent = code; })
      .then(function () { setTimeout(function () { lab.textContent = orig; b.classList.remove('is-copied'); }, 1800); });
  });

  /* ---------- 4. Announcement rotator ---------- */
  function initRotators() {
    var rs = document.querySelectorAll('[data-diwali-rotator]');
    for (var i = 0; i < rs.length; i++) (function (r) {
      var items = r.querySelectorAll('[data-rot-item]');
      if (items.length < 2) return;
      var idx = 0;
      setInterval(function () {
        if (document.hidden) return;
        items[idx].classList.remove('is-active'); items[idx].setAttribute('aria-hidden', 'true');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active'); items[idx].removeAttribute('aria-hidden');
      }, 3600);
    })(rs[i]);
  }

  function init() { updateTimers(); setInterval(updateTimers, 1000); initRotators(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
